


























































































































































import Component from "vue-class-component";
import Vue from "vue";
import EventApi from "../../../api/EventsApi";
import {
    CardSetup,
    StackSetup,
    UploadBackfaceResponse,
    TableItem
} from "../../../../types";
import MessageHelper from "../../../helpers/MessageHelper";
import UploadHelper from "../../../helpers/UploadHelper";

@Component({
    props: {
        stack: {
            required: true,
            type: Object,
        },
        selectedDecks: {
            required: true,
            type: Array
        }
    }
})

export default class FieldDataTableDeck extends Vue {
    private isHidden: boolean = false;
    private cardFaceDragover: boolean = false;
    private stack!: StackSetup;
    private cardFiles: FileList|null = null;
    private readonly DEFAULT_BACKFACE = '/images/test-hand/backface.png';
    private readonly RANDOM_FACE = '/../images/random-el.png';
    private selectedDecks!: Array<string>;
    private randomCardsAmount: string = '1';

    private isSelectedDeck(deckId: number): boolean
    {
        return this.selectedDecks.indexOf(deckId.toString()) !== -1;
    }

    /**
     * Скрыть/показыть список карт в колоде
     * @private
     */
    private toggleDeckVisibility(): void
    {
        this.isHidden = !this.isHidden;
    }

    /**
     * Скрыть/показыть карту на столе
     * @param id
     * @param stackId
     * @private
     */
    private toggleCardVisibility(id: string, stackId: string): void
    {
        let data = {
            id: id,
            stackId: stackId,
        };

        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_ON_TABLE_STATUS, data);
    }

    /**
     * Изменить вечность (неудаляемость) карты
     * @param id
     * @param stackId
     * @private
     */
    private toggleCardEternity(id: string, stackId: string): void
    {
        let data = {
            id: id,
            stackId: stackId,
        };

        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_ETERNITY_STATUS, data);
    }

    /**
     * Удалить карту
     * @param id
     * @private
     */
    private deleteCard(id: string): void
    {
        let data = {
            ids: [id],
        };

        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_DELETE_CARDS, data);
    }

    /**
     * Удалить стопку
     * @param id
     * @private
     */
    private deleteStack(id: string): void
    {
        let data = {
            ids: [id],
        };

        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_DELETE_STACKS, data)
    }

    /**
     * Зазумить карту
     * @param image
     * @private
     */
    private zoomImage(image: string): void
    {
        EventApi.triggerEvent(EventApi.ZOOM_ITEMS, [image]);
    }

    private addRandomCard(): void
    {
        const pixiScene = window.PixiScene;
        if (!pixiScene) {
            return;
        }
        let pos = pixiScene.getSceneCenter();
        let data = {
            id: this.stack.id.toString(),
            x: pos.x - this.stack.width/2,
            y: pos.y - this.stack.height/2,
            count: this.randomCardsAmount
        };

        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_CREATE_RANDOM_ELEMENT, data);

    }

    /**
     * Начать перенос карты из таблицы
     * @param card
     * @param e
     * @param isRandom
     * @private
     */
    private startDragCard(e: Event, isRandom: boolean, card?: CardSetup): void
    {
        const container = document.getElementById('tableStage');
        if (!container) {
            return;
        }
        const target = e.target as any;
        const targetRect = target.getBoundingClientRect();
        const x = targetRect.x;
        const y = targetRect.y;
        let itemConfig: TableItem = {
            face_src: '',
            backface_src: '',
            id: '',
            width: this.stack.width,
            height: this.stack.height,
            x: x,
            y: y,
        };
        if (card) {
            itemConfig = {
                face_src: card.face_src,
                backface_src: card.backface_src,
                id: card.id,
                width: this.stack.width,
                height: this.stack.height,
                x: x,
                y: y,
                zIndex: card.zIndex,
                flipped: card.flipped
            };
        }

        if (isRandom) {
            itemConfig = {
                face_src: '',
                backface_src: '',
                id: this.stack.id.toString(),
                deck_id: this.stack.id.toString(),
                width: this.stack.width,
                height: this.stack.height,
                x: x,
                y: y,
                type: 2,
                is_random: true
            };
        }
    }

    /**
     * Загрузить новую рубашку для выбранной карты
     * @param card
     * @param e
     * @private
     */
    private loadBackface(card: CardSetup, e: Event): void
    {
        const fileInput = e.target as HTMLInputElement;
        const files = fileInput.files;

        if (files && files[0]) {
            let formData = new FormData();
            formData.append('backface', files[0]);

            UploadHelper.uploadBackfaceRequest(formData, '/profile/upload-backface')
                .then((result: UploadBackfaceResponse) => {
                    if (result.success && result.backface) {
                        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_CARD_BACKFACE, {
                            id: card.id,
                            backface: result.backface,
                        });
                        fileInput.value = '';
                    } else {
                        alert('Ошибка загрузки рубашки');
                        fileInput.value = '';
                    }
                }).catch(() => {
                alert('Ошибка загрузки файлов');
                fileInput.value = '';
            });
        }
    }

    /**
     * Добавить карту в существующую стопку
     * @param e
     * @private
     */
    private addCard(e: DragEvent): void
    {
        this.cardFaceDragover = false;

        if (e.dataTransfer && e.dataTransfer.files) {
            e.preventDefault();
            this.cardFiles = e.dataTransfer.files;
            if (this.cardFiles.length > 1) {
                this.$emit('show-upload-form', this.cardFiles);
            }
        }
    }

    /**
     * Показать кнопку удаления рубашки
     * @param src
     * @private
     */
    private showDeleteBackfaceButton(src: string): boolean
    {
        return src !== this.DEFAULT_BACKFACE;
    }

    private makeFieldEditable(e: Event): void
    {
        (e.target as HTMLInputElement).readOnly = false;
    }

    private makeFieldReadonly(e: Event): void
    {
        (e.target as HTMLInputElement).readOnly = true;
        alert(`Name changed to ${(e.target as HTMLInputElement).value}`)
    }

    private changeDeckBackface(e: Event): void {
        const input = e.target as HTMLInputElement;
        const files: FileList | null = input.files;
        if (files && typeof files[0] !== 'undefined') {
            alert(files[0]);
        }
    }

    /**
     * Удаление рубашки
     *
     * При удалении рубашки устанавливаем ей стандартную
     * @param id
     * @private
     */
    private deleteBackface(id: number): void
    {
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_CARD_BACKFACE, {
            id: id,
            backface: this.DEFAULT_BACKFACE,
        });
    }

    /**
     * Изменить мета-информацию карты
     * @param id
     * @param e
     * @private
     */
    private changeMetaInfo(id: number, e: Event): void
    {
        (e.target as HTMLInputElement).readOnly = true;
        FieldDataTableDeck.changeMetaData(id, 'information', (e.target as HTMLInputElement).value);
    }

    /**
     * Изменить мета-тип карты
     * @param id
     * @param e
     * @private
     */
    private changeMetaType(id: number, e: Event): void
    {
        (e.target as HTMLInputElement).readOnly = true;
        FieldDataTableDeck.changeMetaData(id, 'type', (e.target as HTMLInputElement).value);
    }

    /**
     * Изменить мета-данные карты
     * @param id
     * @param type
     * @param data
     * @private
     */
    private static changeMetaData(id:number, type: string, data: string): void
    {
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_META_DATA, {
            id: id,
            data: data,
            type: type,
        });
    }

    /**
     * Изменить название стопки
     * @param id
     * @param e
     * @private
     */
    private changeStackTitle(id: Number, e: Event): void
    {
        (e.target as HTMLInputElement).readOnly = true;

        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_CHANGE_STACK_TITLE, {
            id: id,
            title: (e.target as HTMLInputElement).value,
        });
    }

    /**
     * Показать карту в таблице
     * @param card
     * @param stack
     * @private
     */
    private showCardInTable(card: CardSetup, stack: StackSetup): boolean
    {
        if (card.type === 1) {
            return true;
        }

        return card.type === 2 && stack.cards.length > 1;
    }
}
